import { render, staticRenderFns } from "./ProfileKeywordSettingLayout.vue?vue&type=template&id=b796d382"
import script from "./ProfileKeywordSettingLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileKeywordSettingLayout.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports